import React from "react";

export default function UseCaseCompIcon() {
  return (
    <svg
      width="71"
      height="69"
      viewBox="0 0 71 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M66.751 67.75H58.251V28.1699L66.751 25.3584V67.75ZM48.751 67.75H40.251V47.335L48.751 44.5234V67.75ZM30.751 67.75H22.251V38.4023L30.751 35.5898V67.75ZM12.751 67.75H4.25098V56.2686L12.751 53.457V67.75ZM17.5078 27.6084L11.501 33.5703L5.49609 27.6084L11.501 21.6416L17.5078 27.6084ZM47.5117 24.6309L41.501 30.5957L35.4951 24.6279L41.501 18.6641L47.5117 24.6309ZM32.5107 12.7197L26.501 18.6846L20.4951 12.7168L26.501 6.75293L32.5107 12.7197ZM65.5088 7.31836L59.501 13.2822L53.4922 7.3125L59.5 1.35156L65.5088 7.31836Z"
        fill="#065B70"
        stroke="#E6FAFC"
        strokeWidth="0.5"
      />
      <path
        d="M66.751 67.75H58.251V33.9355L66.751 31.123V67.75ZM48.751 67.75H40.251V53.291L48.751 50.4795V67.75ZM30.751 67.75H22.251V44.3574L30.751 41.5459V67.75ZM12.751 67.75H4.25098V62.2246L12.751 59.4121V67.75ZM17.5078 27.6064L11.751 33.3242V21.8896L17.5078 27.6064ZM47.5088 24.6279L41.751 30.3467V18.9121L47.5088 24.6279ZM32.5088 12.7168L26.751 18.4355V7.00098L32.5088 12.7168ZM65.5088 7.31543L59.751 13.0342V1.59961L65.5088 7.31543Z"
        fill="#35D7E4"
        stroke="#E6FAFC"
        strokeWidth="0.5"
      />
      <path
        d="M1 68H70M14.683 24.45L23.317 15.877M31.183 14.3881L38.317 21.4722M44.641 21.4305L56.359 10.517M13 53.1111L4 56.0889V68H13V53.1111ZM31 35.2444L22 38.2222V68H31V35.2444ZM49 44.1778L40 47.1556V68H49V44.1778ZM67 25.0128L58 27.9906V68H67V25.0128ZM59.5 1L53.137 7.31289L59.5 13.6347L65.863 7.31884L59.5 1ZM41.5 18.3158L35.14 24.6316L41.5 30.9475L47.863 24.6346L41.5 18.3158ZM26.5 6.40467L20.14 12.7205L26.5 19.0394L32.866 12.7205L26.5 6.40467ZM11.5 21.2906L5.14 27.6064L11.5 33.9253L17.866 27.6064L11.5 21.2906Z"
        stroke="#E6FAFC"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
